import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { Slot, Text, Button, Skeleton, Tooltip } from '@costar-ui/components';
import React, { useMemo } from 'react';

var tooltipDefaultProps = {
  placement: 'right',
  offset: 12,
  shouldFlip: true
};
var Specialties = function Specialties(props) {
  var primarySpecialty = props.primarySpecialty,
    specialties = props.specialties,
    testId = props.testId,
    isLoading = props.isLoading;
  var specialtiesList = useMemo(function () {
    return primarySpecialty ? specialties === null || specialties === void 0 ? void 0 : specialties.filter(function (x) {
      return x !== primarySpecialty;
    }) : specialties;
  }, [primarySpecialty, specialties]);
  var tooltipContent = useMemo(function () {
    return /*#__PURE__*/React.createElement(Slot, {
      direction: "vertical",
      gap: "sm",
      testId: "specialties-list",
      "data-testid": testId
    }, specialtiesList === null || specialtiesList === void 0 ? void 0 : specialtiesList.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Text, {
        key: item + index,
        testId: "specialties-list-item-".concat(index)
      }, item);
    }));
  }, [specialtiesList, testId]);
  var anchorElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(Slot, {
      gap: "xs",
      testId: "primary-specialty"
    }, /*#__PURE__*/React.createElement(Text, {
      testId: "primary-specialty-label"
    }, primarySpecialty), /*#__PURE__*/React.createElement(Button, {
      variant: "ghost-secondary",
      size: "fit-0-std",
      testId: "specialties-count-button"
    }, specialtiesList !== null && specialtiesList !== void 0 && specialtiesList.length ? " +".concat(specialtiesList.length) : ''));
  }, [primarySpecialty, specialtiesList === null || specialtiesList === void 0 ? void 0 : specialtiesList.length]);
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.375",
    className: "csg-tw-skeleton-specialties"
  }) : (specialties || primarySpecialty) && /*#__PURE__*/React.createElement(React.Fragment, null, primarySpecialty ? specialtiesList && (specialtiesList === null || specialtiesList === void 0 ? void 0 : specialtiesList.length) >= 1 ? /*#__PURE__*/React.createElement(Tooltip, _extends({
    anchorElement: anchorElement
  }, tooltipDefaultProps), tooltipContent) : /*#__PURE__*/React.createElement(Text, {
    testId: "primary-specialty-label",
    className: "wrap-anywhere"
  }, primarySpecialty) : null);
};

export { Specialties };
//# sourceMappingURL=specialties.esm.js.map
